import "./App.css";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import Home from "./components/home/home";
import Aboutus from "./components/about us/aboutus";
import Gallery from "./components/gallery/gallery";
import Contact from "./components/contactus/contactus";
import DonateNow from "./components/donatenow/donatenow";
import Dashboard from "./components/profile/dashboard";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-center" 
        toastOptions={{
          success: {
            style: {
              background: '#bcedeb',
              color: '#036666',
              border: '1px solid #75cabb',
              fontWeight: 500
            },
            iconTheme: {
              primary: '#036666',
              secondary: '#bcedeb',
            },
          },
          error: {
            style: {
              background: '#fde3e9',
              color: '#9e0034',
              border: '1px solid #f6b5c6',
              fontWeight: 500
            },
            iconTheme: {
              primary: '#9e0034',
              secondary: '#fde3e9',
            },
          },
        }}
      />
      <BrowserRouter>
        <Header></Header>
        <Routes>
          <Route path="/" element={<Navigate to="/home"></Navigate>} />
          <Route path="/home" element={<Home></Home>} />
          <Route path="/contactus" element={<Contact></Contact>} />
          <Route path="/aboutus" element={<Aboutus></Aboutus>} />
          <Route path="/gallery" element={<Gallery></Gallery>} />
          <Route path="/donatenow" element={<DonateNow></DonateNow>} />
          <Route path="/dashboard" element={<Dashboard></Dashboard>} />
        </Routes>
        <Footer></Footer>
      </BrowserRouter>

    </div>
  );
}

export default App;
